import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../../shared/services/loader/loader.service';
import { REQUISICAO_SILENCIOSA } from '../../shared/services/loader/requisicao-silenciosa';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: LoaderService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Requisição de segundo plano (ping de sessão, polling): não acende o overlay.
    if (req.context.get(REQUISICAO_SILENCIOSA)) {
      return next.handle(req);
    }

    this.loaderService.showLoader();
    return next.handle(req).pipe(
      finalize(() => this.loaderService.hideLoader())
    );
  }
}
;
